/**
 * @generated SignedSource<<110669bc5712b3aaa5375f0556a88c68>>
 * @relayHash c9ca4dc87d7c1b4565eb911df8516d1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cdd92af0747404310421f4571bdd6507ac1f6fdf50708f5065f81af4c579262b

import type { ConcreteRequest } from 'relay-runtime';
export type useGetCurrentStorageUsageQuery$variables = Record<PropertyKey, never>;
export type useGetCurrentStorageUsageQuery$data = {
  readonly storage: {
    readonly bytesLimit: AGG$Long | null;
    readonly bytesUsed: AGG$Long;
    readonly gracePeriodEndDate: string | null;
    readonly isStorageEnforcementGracePeriodComplete: boolean | null;
    readonly isUnlimited: boolean | null;
  } | null;
};
export type useGetCurrentStorageUsageQuery = {
  response: useGetCurrentStorageUsageQuery$data;
  variables: useGetCurrentStorageUsageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "storage",
    "concreteType": "ConfluenceStorage",
    "kind": "LinkedField",
    "name": "confluence_storage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "bytesUsed"
      },
      {
        "kind": "ScalarField",
        "name": "bytesLimit"
      },
      {
        "kind": "ScalarField",
        "name": "isUnlimited"
      },
      {
        "kind": "ScalarField",
        "name": "isStorageEnforcementGracePeriodComplete"
      },
      {
        "kind": "ScalarField",
        "name": "gracePeriodEndDate"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useGetCurrentStorageUsageQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useGetCurrentStorageUsageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c9ca4dc87d7c1b4565eb911df8516d1b",
    "id": "cdd92af0747404310421f4571bdd6507ac1f6fdf50708f5065f81af4c579262b",
    "metadata": {},
    "name": "useGetCurrentStorageUsageQuery",
    "operationKind": "query",
    "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,bytesLimit,isUnlimited,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
  }
};
})();

(node as any).hash = "5b53f7e45b7378c585a91224c689138b";

export default node;
